import React from "react";

//Material-ui / core
import { GridLegacy, Grow } from "@mui/material";

//Main components
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

//Variabelen
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import TranslatableEditor from "../../../components/TranslatableEditor/TranslatableEditor";
import { useController, useWatch } from "react-hook-form";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";

function Betweenorder() {
  const {
    field: { value: extra_settings_id },
  } = useController({ name: "extra_settings__id" });
  const enabled = useWatch({ name: "extra_settings__betweenOrderQuestionActive" });
  const vestigingId = useWatch({ name: "id" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <h3>
              <TranslationWrapper
                tDefault={"Between-Order-Page Settings"}
                tKey={"vestigingen.form.betweenOrder.headers.betweenOrderSettings"}
              />
            </h3>
            <FormSwitchTC
              name={"extra_settings__betweenOrderQuestionActive"}
              tDefault={"Actief"}
              tKey={"vestigingen.form.betweenorder.label.extra_settings__betweenOrderQuestionActive"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
      <Grow in={Boolean(enabled)} mountOnEnter unmountOnExit>
        <Card>
          <CardBody>
            <FormAsyncTC
              async={{
                url: `core/vouchers/search?fields=vouchercode as label, vouchercode as value&vestiging_id=${vestigingId}&per_page=50`,
                searchField: "vouchercode",
              }}
              name={"extra_settings__betweenOrderQuestionVoucherCode"}
              primaryKey={"vouchercode"}
              rules={{
                required: true,
              }}
              tDefault={"Voucher korting bij OK"}
              tKey={"vestigingen.form.betweenorder.label.extra_settings__betweenOrderQuestionVoucherCode"}
            />
            {/*<FormTextTC*/}
            {/*  name={"extra_settings__betweenOrderQuestionVoucherCode"}*/}
            {/*  tKey={"vestigingen.form.betweenorder.label.extra_settings__betweenOrderQuestionVoucherCode"}*/}
            {/*  tDefault={"Voucher korting bij OK"}*/}
            {/*/>*/}
            <FormFieldTwoColumns
              label={
                <TranslationWrapper
                  tDefault={"Bericht"}
                  tKey={"vestigingen.form.betweenorder.label.extra_settings__betweenOrderQuestionMessage"}
                />
              }
            >
              <TranslatableEditor
                contentName={"betweenOrderContent"}
                endpointParams={{
                  id: extra_settings_id,
                  model_name: "extra_settings",
                }}
                textFields={[
                  {
                    name: "betweenOrderTitle",
                    label: { tKey: "betweenOrder.translatableEditor.label.title", tDefault: "Title" },
                  },
                  {
                    name: "betweenOrderOkText",
                    label: {
                      tKey: "betweenOrder.translatableEditor.label.ok",
                      tDefault: "Ok button text",
                    },
                  },
                  {
                    name: "betweenOrderCancelText",
                    label: {
                      tKey: "betweenOrder.translatableEditor.label.cancel",
                      tDefault: "Cancel button text",
                    },
                  },
                ]}
              />
            </FormFieldTwoColumns>
          </CardBody>
        </Card>
      </Grow>
    </div>
  );
}

export default Betweenorder;
